import React  from 'react';
import DeleteModal from "../../../../Modals/DeleteModal";
import CustomTable from "../../../../../components/table/CustomTable";
import {ButtonLargeTransparent} from "../../../../../components/buttons/ButtonLargeTransparent";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {TrashOutlineIcon} from "../../../../../components/buttons/IconButtons";
import DividerWithText from "../../../../../components/DividerWithText";
import AcrTableApp from "../Functionality/AcrTableApp";
import CreateAcrModal from "../../Acrs/Modal/CreateAcrModal";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AcrTable = ({ defaultSioList, disabled }) => {
    const {
        t,
        id,
        thead,
        tbody,
        tableId,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        deleteShow,
        setDeleteShow,
        showCreateModal,
        setShowCreateModal,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelected
    } = AcrTableApp({ defaultSioList });

    return (
        <>
            <div className='row mt-4'>
                <DividerWithText title={t('acrs')} />
                {!disabled && (
                <div className='d-flex justify-content-end mb-2'>
                    <ButtonAction
                        id='btn_at_delete_acr'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteShow(true);
                        }}
                    />
                </div>
                )}
                <CustomTable
                    tableId={tableId}
                    checkbox={!disabled}
                    checkboxTitle={"de_/_select_all"}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    withoutHeight={true}
                />
                {!disabled && (
                <div className='my-2'>
                    <ButtonLargeTransparent
                        id="btn_at_create_acr"
                        click={() => {
                            setShowCreateModal(true);
                        }}
                        text={t("create_acr")}
                    />
                </div>
                )}

            </div>

            {showCreateModal &&
                <CreateAcrModal
                    controllerId={id}
                    show={showCreateModal}
                    onHide={() =>  setShowCreateModal(false)}
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={deleteShow}
                onHide={() => setDeleteShow(false)}
                onClickFn={() => deleteSelected()}
                data={selectedList}
                isReset={setSelectedList}
                isAllReset={setIsAllChecked}
                title_modal={t('delete_acr')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('acrs')}
            />
        </>
    );
};

export default AcrTable;
